var $aca782271fda5aaa$exports = {};
$aca782271fda5aaa$exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};


export {$aca782271fda5aaa$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
